const myHeaders = new Headers();
myHeaders.append("accept", "application/json");
myHeaders.append("api-key", "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");
myHeaders.append("content-type", "application/json");

const url = "https://api.sendinblue.com/v3/smtp/email";

export const  sendMailForReg = async (email, name) => {
  return;
    var raw = JSON.stringify({
        "sender": {
          "name": "Prime Finance",
          "email": "support@primelmtd.com"
        },
        "to": [
          {
            "email": email,
            "name": name
          }
        ],
        "templateId": 1,
        "params": {
          "name": name,
        }
      });
    
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

        try {
            const response = await fetch(url, requestOptions);
            if(response.status === 201){
                console.log("mail sent")
            }else{
                console.log("mail not sent")
            }
        }  catch (error) { 
            console.log(error);
        }
}

export const  sendMailForTransaction = async (email, name, amount, type, status) => {
  return;
    var raw = JSON.stringify({
        "sender": {
          "name": "Prime Finance",
          "email": "support@primelmtd.com"
        },
        "to": [
          {
            "email": email,
            "name": name
          }
        ],
        "templateId": 2,
        "params": {
          "name": name,
          "type": type,
          "amount": amount,
          "status": status
        }
      });
      
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      try {
        const response = await fetch(url, requestOptions);
        if(response.status === 201){
            console.log("mail sent")
        }else{
            console.log("mail not sent")
        }
    }  catch (error) { 
        console.log(error);
    }
}